import { useRef, useState } from "react";
import {
    ResponsiveContainer,
    BarChart,
    XAxis,
    YAxis,
    Bar
} from "recharts";
import { numberFormatter } from "../../utils";
import { Tooltip, Whisper } from "rsuite";
import InfoOutlineIcon from '@rsuite/icons/InfoOutline';

const TopPotentialCustomers = (props: any) => {
    const {data}=props
    const [tooltip, setTooltip] = useState<any>({ district: "", show: false, costPercent: 0, l4Category: "" })
    
    const renderCustomizedLabel = (props: any) => {
        const { x, y, width, values, height } = props;
        return (
            <>
                {values?.category?.length > 0 && width > 180 && (
                    <text
                        x={x + width / 2}
                        y={y - (values.category.length > 0 ? -(height - 10) : -(height - 10))}
                        fill="#fff"
                        textAnchor="middle"
                        dominantBaseline="middle"
                        className={values.category.length > 15 && width < 180 || values.category.length > 30 && width < 400 ? 'text-[1.2vh] text-wrap' : 'text-[1.5vh] text-wrap'}
                    >
                        {values.category}
                    </text>
                )}
            </>
        );
    };

    const onHover = (data: any, index: number) => {
      console.log(data,123)
      setTooltip({ show: true, type: data.payload.district, data: data.payload })
    }

    const onOut = () => {
        setTooltip({ show: false, district: "", costPercent: "" });
    }

    return (
      <>
      <table className="common-table-ui">
          <thead>
          <tr>
            <th></th>
            <th></th>
            <th className="text-[1.5vh] px-[1vh]"> GB Market Share </th>
            <th className="text-[1.5vh] px-[1vh]"> Opportunity
               <Whisper
                  placement="left"
                  speaker={
                    <Tooltip>
                      <div>
                      Opportunity is identified for customers with industry sales over $10M whose wallet share with Graybar is below the district market share. The opportunity equals the gap between district market share and wallet share, multiplied by total industry sales
                      </div>
                    </Tooltip>
                  }
                >
                  <InfoOutlineIcon className="!ml-[3px] mb-[.5vh]" />
                </Whisper>
            </th>
          </tr>
        </thead>
        <tbody>
          {data?.map((d: any, index: any) => {
            return (
              <tr key={index} className="h-[2vh] text-center">
                <td className="w-[10%] text-center">{d.district}</td>
                <td className=" h-full flex w-full">
                  <ResponsiveContainer
                    width={`${(d.nineProductPart / data[0].nineProductPart) * 100 < 20 ? ((d.nineProductPart / data[0].nineProductPart) * 100) + 3: (d.nineProductPart / data[0].nineProductPart) * 100  }%`}
                    height="80%"
                    minHeight={"3.5vh"}
                  >
                    <BarChart data={[d]} layout="vertical" stackOffset="expand">
                      <XAxis hide type="number" />
                      <YAxis hide type="category" dataKey="district" />
                      <Bar
                            key={"gbSalesPart"}
                            dataKey={"gbSalesPart"}
                            stackId="a"
                            barSize={10}
                            onMouseEnter={(a: any, index) =>
                              onHover(a.tooltipPayload[0], index)
                            }
                            onMouseLeave={onOut}
                            fill={'#F58427'}
                          >

                          </Bar>
                          <Bar
                            key={"nineProductPart"}
                            dataKey={"nineProductPart"}
                            stackId="a"
                            barSize={10}
                            onMouseEnter={(a: any, index) =>
                              onHover(a.tooltipPayload[0], index)
                            }
                            onMouseLeave={onOut}
                            fill={'#006400'}
                          >

                          </Bar>
                          
                      {/* {< ReferenceLine x={0.8} isFront={true} strokeWidth={3} label={index % 5 == 0 && { position: 'top', fill: '#a4f504', value: "80% Spend", fontStyle: 'italic' }}></ReferenceLine>} */}
                    </BarChart>
                  </ResponsiveContainer>
                  {/* <span>{numberFormatter(d.netcost, 2)}</span> */}
                  {tooltip.show && tooltip.type == d.district && (
                   
                    <div
											  style={{
                          position: "absolute",
                          bottom: "30vh",
                          right: '24.5vw',
                          zIndex: 999,
                          width: "fit-content",
                          background: "white",
                          border: "1px solid #ccc",
                          boxShadow:
                            "0 2px 5px rgba(0,0,0,0.2)",
                          borderRadius: "1vh",
                          cursor: "pointer",
                          color: "black",
                          opacity: 0.97,
                        }}
										>
											{/* Header Row */}
											<div className="w-full flex justify-start h-[3vh] items-center bg-[#f0f4f8] py-[3vh] px-[1vh] textSmall">
												<div className="font-bold uppercase">
													{tooltip?.type}
												</div>
												<div
													className="font-bold ml-1"
													style={{ color: "#3f3f3f" }}
												>
													
												</div>
											</div>
											{/* Data Row */}
											<div className="h-fit p-[1vh] mt-[.5vh] mb-[.5vh]">
												<p
													className="label"
													style={{
														padding: "0",
														margin: "0",
													}}
												>
													<label
														className="graph-label-small"
														style={{
															color: "#5a5a5a",
															fontWeight:
																"normal",
														}}
													>
														Total Potential:{" "}
													</label>
													<label
														className="graph-label-small"
														style={{
															color: "#3f3f3f",
															fontWeight: "bold",
														}}
													>
														 {numberFormatter(tooltip.data?.nineProductPart, 2,'$')}
													</label>
												</p>
												<p
													className="label"
													style={{
														padding: "0",
														margin: "0",
													}}
												>
													<label
														className="graph-label-small"
														style={{
															color: "#5a5a5a",
															fontWeight:
																"normal",
														}}
													>
														Actual GB Sales:{" "}
													</label>
													<label
														className="graph-label-small"
														style={{
															color: "#3f3f3f",
															fontWeight: "bold",
														}}
													>
														{numberFormatter(tooltip.data?.gbSalesPart, 2,'$')}
													</label>
												</p>
                        
											</div>
										</div>
                    
                  )}
                </td>
                <td>{(d?.gbSharePart*100)?.toFixed(2)}%</td>
                <td>{numberFormatter(d?.opportunity,2,'$')}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
        <div className="contentFooter !justify-between">
				  <CustomLegend></CustomLegend>
        </div>
      </>
    );
}

const CustomLegend = () => (
	<div
		style={{
			display: "flex",
			gap: "1rem",
			alignItems: "center",
			color: "black",
			fontSize: "0.8rem",
		}}
	>
		<span>
			<span
				style={{
					display: "inline-block",
					width: 10,
					height: 18,
					background: "#F58427",
					marginRight: 8,
					verticalAlign: "middle",
				}}
			/>
			GB Sales
		</span>
    <span>
			<span
				style={{
					display: "inline-block",
					width: 10,
					height: 18,
					background: "#006400",
					marginRight: 8,
					verticalAlign: "middle",
				}}
			/>
			Potential Sales
		</span>
	</div>
);

export default TopPotentialCustomers;